<template>
  <div class="marquee">
    <MarqueeTips
      v-if="tickerInfo.enabled"
      :style="tickerStyle"
      :class="tickerSizeClass"
      :content="tickerInfo.message"
      :speed="10"
    />
  </div>
</template>
<script>
import MarqueeTips from 'vue-marquee-tips';

export default {
  name: 'Ticker',
  components: {
    MarqueeTips
  },
  computed: {
    tickerStyle() {
      return this.$store.getters.tickerStyle;
    },
    tickerInfo() {
      return this.$store.getters.tickerInfo;
    },
    tickerSizeClass() {
      return 'marquee-' + this.tickerInfo.size;
    }
  }
};
</script>

<style scoped>
.marquee-small{
 position: fixed;
 width: 100%;
 height: 50px;
 line-height: 50px;
 bottom: 30px;
 font-size: 30px;
}
.marquee-medium{
 position: fixed;
 width: 100%;
 height: 80px;
 line-height: 80px;
 bottom: 30px;
 font-size: 60px;
}
.marquee-large{
 position: fixed;
 width: 100%;
 height: 120px;
 line-height: 120px;
 bottom: 30px;
 font-size: 80px;
}
</style>



// WEBPACK FOOTER //
// Ticker.vue?2c35fb24